
import util,{_} from '@/libs/util'
import common from '@/libs/common.mixin'
import { mapState } from 'vuex'
import Loading from 'vux/src/components/loading/index.vue'

export default {
name: 'app',
mixins:[common],
components: {
Loading
},
watch: {
'$store.state.sys_name': function (val) {
let title = window.document.title
if(val){
title = title.split(' - ')[0]
util.title(title,val)
}
}
},
mounted(){
this.init()
},
computed: {
...mapState({
direction: state => state.direction.direction
}),
isLoading: {
get: function () {
return this.$store.state.isLoading
},
set: function(newVal) {
this.$store.state.isLoading = newVal
}
}
},
methods:{
init(){
this.init_ui_config()
this.init_wechat_env()
},
init_ui_config(){
if(!_.isEmpty(window.UI_CONFIG)){
this.$store.commit('setUiConfig',window.UI_CONFIG)
}else{
this.$store.dispatch('getUiConfig')
}
if(!_.isEmpty(window.CLIENT_PARAMS.mobile) && window.CLIENT_PARAMS.mobile.system_name != ''){
this.$store.commit('setSysName',window.CLIENT_PARAMS.mobile.system_name)
}
},
init_wechat_env(){
if(util.isWechat()){

this.$store.dispatch('getJssdkConfig',this.$wechat)
}

}
}
}



// WEBPACK FOOTER //
// ./src/app.vue